var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontAccent } from 'Styles/fonts';
export var ProductDonationCount = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: var(--foreground);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n"], ["\n  ", ";\n  color: var(--foreground);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n"])), fontAccent(16));
export default {};
var templateObject_1;
